$(document).ready(function(){
$('.el-collection-tabs ul a[href="#tab1"]').addClass('el-active');  
});


$(document).on("click", "a[href='#tab1']", function (e) {
  e.preventDefault();
$('.el-collection-tabs ul a').removeClass('el-active'); 
$(this).addClass('el-active'); 
$('.el-collection-tabs-content').removeClass('el-active'); 
$('.el-collection-tabs-content1').addClass('el-active'); 
});
$(document).on("click", "a[href='#tab2']", function (e) {
  e.preventDefault();
$('.el-collection-tabs ul a').removeClass('el-active'); 
$(this).addClass('el-active'); 
$('.el-collection-tabs-content').removeClass('el-active'); 
$('.el-collection-tabs-content2').addClass('el-active'); 
});



$(document).ready(function(){

  $(document).on('click', '.el-collection-tabs p', function(){
    $('.el-sort-drawer').addClass('active');
    $('body').addClass('el-sort-open');
  });

  $(document).on('click', '.el-sort-close, .el-sort-overlay', function(){
    $('.el-sort-drawer').removeClass('active');
    $('body').removeClass('el-sort-open');
  });

  $(document).on('click', '.el-sort-item', function(){

    $('.el-sort-item').removeClass('active');
    $(this).addClass('active');

    var sortValue = $(this).data('sort');

    var url = new URL(window.location.href);

    url.searchParams.set('sort_by', sortValue);

    window.location.href = url.toString();

  });

});


  $(document).on('click', '.el-load-more-js', function(){
    $('body').addClass('el-load-all-products');
  });
  $(document).on('click', '.el-load-less-js', function(){
    $('body').removeClass('el-load-all-products');
  });
  $(document).ready(function () {

  var urlParams = new URLSearchParams(window.location.search);
  var currentSort = urlParams.get('sort_by') || 'manual';

  $('.el-sort-item').removeClass('active');

  $('.el-sort-item').each(function () {
    if ($(this).data('sort') == currentSort) {
      $(this).addClass('active');
    }
  });

});